// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  oauth: {
    defaultProvider: 'cyncly',
    cyncly: {
      issuer: 'https://dev-login.cyncly.com',
      clientId: 'promob-connect-cf',
      loginUrl: 'https://dev-login.cyncly.com/connect/authorize',
      logoutUrl: 'https://dev-login.cyncly.com/connect/endsession',
      tokenEndpoint: 'https://dev-login.cyncly.com/connect/token',
      userinfoEndpoint: 'https://dev-login.cyncly.com/connect/userinfo',
      redirectUri: 'https://connect-dev.promob.com/authenticate',
      postLogoutRedirectUri: 'https://connect-dev.promob.com/logout',
      silentRefreshRedirectUri: 'https://connect-dev.promob.com/silent-refresh.html',
      scope: 'openid profile email offline_access'
    }
  },
  apiUris: {
    //companyApiUri: "http://localhost:7071/api",
    companyApiUri: "https://func-company-qa-eastus2-001.azurewebsites.net/api",
    //chartsApiUri: "http://localhost:7072/api",
    chartsApiUri: "https://func-summaries-dev-eastus2-001.azurewebsites.net/api",
    //projectsApiUri: "http://localhost:7073/api",
    projectsApiUri: "https://func-connect-dev-eastus2.promob.com/api",
    identitiesApiUri: "https://api.promob.com/v1/Identities",
    //connectSettings: "http://localhost:7074/api"
    connectSettings: "https://func-connect-settings-dev-eastus2-001.azurewebsites.net/api"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
